<template>
  <a-card :bordered="false">
   <div style="display:flex;align-items: flex-end;">
        <a-form :model='audiData' ref="audiForm" :label-col="{span:7}" :wrapper-col="{span:17}" :rules="rules" style="width:600px">
          <a-form-item label="认证ID" v-if="$route.query.type=='detail'">
            {{audiData.id}}
          </a-form-item>
              <a-form-item label="状态" v-if="$route.query.type=='detail'">
                 {{audiData.verify_status_title}}
          </a-form-item>
          <a-form-item label="拒绝原因" v-if="audiData.verify_msg">
             {{audiData.verify_msg}}
          </a-form-item>
          <a-form-item label="认证名称" prop="name">
            <a-input v-model:value="audiData.name" ></a-input>
          </a-form-item>
          <a-form-item label="备注">
            <a-textarea  v-model:value="audiData.remarks" auto-size  />
          </a-form-item>
          <!-- <a-form-item label="公司名称" v-if="$route.query.type=='detail'">
           {{audiData.verify_status_title}}
          </a-form-item> -->
          <a-form-item label="首次扫码提示" prop="first_tips_title">
            <a-input v-model:value="audiData.first_tips_title" placeholder="请输入首次扫码标题提示语" :disabled="$route.query.type=='detail'"></a-input>
          </a-form-item>
          <a-form-item label="首次扫码提示语" prop="first_tips_content">
            <a-textarea  v-model:value="audiData.first_tips_content" placeholder="请输入首次扫码提示语" auto-size :disabled="$route.query.type=='detail'" />
          </a-form-item>
          <a-form-item label="重复扫码提示" prop="repeat_tips_title">
            <a-input v-model:value="audiData.repeat_tips_title" placeholder="请输入重复扫码标题提示语" :disabled="$route.query.type=='detail'"></a-input>
          </a-form-item>
          <a-form-item label="重复扫码提示语" prop="repeat_tips_content">
            <a-textarea v-model:value="audiData.repeat_tips_content" :disabled="$route.query.type=='detail'" placeholder="请输入重复扫码提示语" auto-size />
          </a-form-item>
            <a-form-item :wrapper-col="{offset:5}">
            <a-button @click="$router.go(-1)" :loading="loading" class="m-r-10">
              取消
            </a-button>
            <a-button type="primary" @click="submit" :loading="loading" >
              提交
            </a-button>
          </a-form-item>
        </a-form>
        <div style="display: flex;flex-direction: column;justify-content: center;height: 100%;width: 100%;margin-left:40px;margin-bottom:90px">
          <P>变量规则:</P>
          <p>
            <a-tooltip placement="topRight">
              <template #title>
                <span>该参数直接读取您系统开户时的品牌商名称，点击放到提示中可自动获取提示。</span>
              </template>
              @公司名称@
              <QuestionCircleOutlined />
            </a-tooltip>
          </p>
          <p>
            <a-tooltip placement="topRight">
              <template #title>
                <span>该参数为变量，根据首次的扫码时间显示。</span>
              </template>
              @扫码时间@
              <QuestionCircleOutlined />
            </a-tooltip>
          </p>
          <p>
            <a-tooltip placement="topRight">
              <template #title>
                <span>该参数为变量，根据当前的累计扫码次数自动显示。</span>
              </template>
              @扫码次数@
              <QuestionCircleOutlined />
            </a-tooltip>
          </p>
          <p>
            <a-tooltip placement="topRight">
              <template #title>
                <span>该参数为变量，根据首次扫码地区自动显示。</span>
              </template>
              @扫码地区@
              <QuestionCircleOutlined />
            </a-tooltip>
          </p>
        </div>
   </div>
 
  </a-card>
</template>
<script>
import { ref } from "@vue/reactivity";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { message } from 'ant-design-vue';
import { inject, onMounted } from '@vue/runtime-core';
import { iscode } from '@/utils/app';
import {antisFakeTemCreate,antisFakeTemDetail,antisFakeTemUpdate} from '@/api/qrcode'
export default {
  components: { QuestionCircleOutlined },
  setup() {
    const audiData = ref({});
    const audiForm = ref("");
    const $router=inject('$router')
    const rules = {
      name: [{ required: true, message: "请输入名称" }],
      first_tips_title: [{ required: true, message: "请输入首次标题" }],
      first_tips_content: [{ required: true, message: "请输入首次内容" }],
      repeat_tips_title: [{ required: true, message: "请输入重复标题" }],
      repeat_tips_content: [{ required: true, message: "请输入重复内容" }],
    };
    const loading=ref(false)
    const submit = () => {
      audiForm.value
        .validate()
        .then(async () => {
          loading.value=true
          const hide = message.loading("正在加载中...", 0);
          let res
          if($route.query.id){
          res = await antisFakeTemUpdate($route.query.id,audiData.value).then((res) => res.data)
            .catch((error) => error);
          }else{
          res = await antisFakeTemCreate(audiData.value).then((res) => res.data)
            .catch((error) => error);
          }
            
          if (iscode(res)) {
            message.success(res.msg);
            loading.value=false
            $router.go(-1);
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    const $route=inject('$route')
    const getMore=async ()=>{
      let result=await antisFakeTemDetail($route.query.id).then(res=>res.data).catch(error=>error)
      audiData.value=result.data
    }
    onMounted(()=>{
      if($route.query.id){
        getMore()
      }
    })
    return {
      audiData,
      rules,
      submit,
      audiForm,
      loading
    };
  },
};
</script>